import angular from 'angular';
import Logger from '../../../shared/logger';

export const TalentForEmployerService = (Restangular) => {
    const getTalentForEmployer = function (id) {
        return Restangular.one('talentForEmployer', id)
            .get('')
            .catch(error => Logger.error(error));
    };

    const updateTalentForEmployer = function (id, data) {
        return Restangular.one('talentForEmployer', id)
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const searchTalentForEmployer = function (body) {
        return Restangular.all('talentForEmployer')
            .all('search')
            .post(body)
            .catch(error => Logger.error(error));
    };

    const addTalentForEmployer = function (data) {
        return Restangular.all('talentForEmployer')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const isTalentForEmployerExist = (data) => {
        return Restangular.all('talentForEmployer')
            .all('exist')
            .post(data)
            .catch(error => Logger.error(error));
    };

    return {
        getTalentForEmployer,
        updateTalentForEmployer,
        searchTalentForEmployer,
        addTalentForEmployer,
        isTalentForEmployerExist,
    };
};

angular
    .module('TALENYA-FE')
    .factory('TalentForEmployerService', TalentForEmployerService);

